import { IGridOperator } from 'app/shared/model/grid-operator.model';
import { SwitchingStatus } from 'app/shared/model/enumerations/switching-status.model';

export interface IEan {
  id?: number;
  eanCode?: number;
  switchingStatus?: keyof typeof SwitchingStatus | null;
  isResidential?: boolean | null;
  isComplex?: boolean | null;
  isSmartMeter?: boolean | null;
  gridArea?: string | null;
  bagId?: string | null;
  bagBuildingId?: string | null;
  activeMeterNumber?: string | null;
  gridOperator?: IGridOperator | null;
}

export const defaultValue: Readonly<IEan> = {
  isResidential: false,
  isComplex: false,
  isSmartMeter: false,
};
